export default "__VITE_ASSET__Y$a_I7DY__"